module.exports = "img/flags/AQ.a3f4d16.png";